module.exports = __webpack_public_path__ + "img/shili3.424b4fc2.jpg";